<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

document.title = "Lextend.io";

<script>

document.title = "Lextend.io";

export default {
  name: 'App',
}
</script>
